import React from 'react';
import { Box, CircularProgress, styled } from '@mui/material';
import Logo from 'src/components/Logo';

// Styled root container
const Root = styled('div')(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.background.default,
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  justifyContent: 'center',
  left: 0,
  padding: theme.spacing(3),
  position: 'fixed',
  top: 0,
  width: '100%',
  zIndex: 2000,
}));

function SlashScreen() {
  return (
    <Root>
      <Box
        display="flex"
        justifyContent="center"
        mb={6}
      >
        <Logo sx={{ width: 200, maxWidth: '100%' }} />
      </Box>
      <CircularProgress />
    </Root>
  );
}

export default SlashScreen;
